import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DeliveryTicketComponent } from './delivery-ticket.component';
import { TicketDeliveryCreationComponent } from './ticket-delivery-creation/ticket-delivery-creation.component';

const routes: Routes = [
  {
    path: '',
    component: DeliveryTicketComponent,
    children:
      [
        {
          path: '',
          component: TicketDeliveryCreationComponent
        }
      ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DeliveryTicketRoutingModule { }
